<template>
  <div class="goods__store" v-if="storeInfo">
    <div class="goods__store__content">
      <div class="goods__store__content__top">
        <img
          v-if="storeInfo.shopLogo && storeInfo.shopLogo != ''"
          class="goods__store__content__logo"
          :src="storeInfo.shopLogo"
          alt=""
          @click="linkTo"
        />
        <img v-else class="goods__store__content__logo" :src="require('@/assets/img/shop-logo.png')" @click="linkTo" />
        <div class="goods__store__content__title">
          <p class="goods__store__content__shop__name ellipsis" :title="storeInfo.shopName" @click="linkTo">
            {{ storeInfo.shopName }}
          </p>
          <p class="goods__store__content__desc">{{ storeInfo.merchantEntityName }}</p>
          <p class="goods__store__content__num">
            <span class="goods__store__content__type">{{ storeInfo.itemCount }}种</span>
            <span class="goods__store__content__status">已上架</span>
          </p>
        </div>
      </div>
      <div ref="content" :style="itemStyle" class="goods__store__content__tags" v-if="storeInfo.labels.length">
        <div class="tag" v-for="(item, index) in storeInfo.labels" :key="item + index">{{ item }}</div>
        <template v-if="showMoreContent">
          <i @click="openMore" v-if="showMoreBtn" class="show__more__btn el-icon-arrow-down"></i>
          <i @click="hideMore" v-else class="show__more__btn el-icon-arrow-up"></i>
        </template>
      </div>
      <div class="goods__store__content__desc">配送说明：{{ shippingInfo }}</div>
      <div class="bottom_button">
        <span class="right" @click="linkTo">
          <img :src="require('@/assets/img/shop-icon.png')" alt="" />
          进入店铺
        </span>
        <span @click="$emit('contactCustomerService')">
          <img :src="require('@/assets/img/kefu-icon.png')" alt="" />
          联系商家
        </span>
      </div>
      <!-- <el-button type="text" icon="el-icon-s-shop" @click="linkTo" class="store__button">进入店铺</el-button>
      <el-button type="text" icon="el-icon-service" @click="$emit('contactCustomerService')" class="store__button">
        联系商家
      </el-button> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    shippingInfo: {
      type: String
    },
    storeInfo: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    storeInfo: function () {
      if (this.storeInfo.labels.length) {
        this.$nextTick(() => {
          const limitHeight = this.lineHeight;
          if (this.$refs.content?.offsetHeight > limitHeight) {
            this.height = `${this.lineHeight}px`;
            this.showMoreBtn = true;
            this.showMoreContent = true;
          }
        });
      }
    }
  },
  mounted() {},
  data() {
    return {
      lineHeight: 16,
      showMoreContent: false,
      showMoreBtn: false,
      height: 'auto'
    };
  },
  computed: {
    itemStyle() {
      const style = {
        height: this.height,
        overflow: 'hidden'
      };
      return style;
    }
  },
  methods: {
    linkTo() {
      this.$router.push({ path: `/store/${this.storeInfo.shopId}/homePage` });
    },
    openMore() {
      this.height = 'auto';
      this.showMoreBtn = false;
    },
    hideMore() {
      this.height = `${this.lineHeight}px`;
      this.showMoreBtn = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.goods__store {
  // height: 212px;
  background: #ffffff;
  border: 1px solid #f5f5f5;

  &__content {
    padding: 0 16px;
    &__top {
      padding-top: 16px;
      margin-bottom: 12px;
      display: flex;
    }
    &__logo {
      width: 48px;
      height: 48px;
      border-radius: 48px;
      margin-right: 8px;
      cursor: pointer;
    }
    &__title {
      flex: 1;
    }
    &__shop__name {
      font-size: 16px;
      font-weight: 500;
      color: #595959;
      line-height: 18px;
      margin-bottom: 8px;
      width: 132px;
      cursor: pointer;
    }
    &__name {
      font-size: 12px;
      font-weight: 400;
      color: #8c8c8c;
      line-height: 1;
      margin-bottom: 8px;
      width: 132px;
    }
    &__num {
      line-height: 1;
    }
    &__type {
      margin-right: 12px;
      font-size: 12px;
      font-weight: 400;
      color: #595959;
    }
    &__status {
      font-size: 12px;
      font-weight: 400;
      color: #8c8c8c;
    }
    &__tags {
      display: flex;
      flex-flow: wrap;
      text-align: left;
      padding-right: 16px;
      position: relative;
      .tag {
        display: inline-block;
        margin-bottom: 12px;
        font-size: 12px;
        height: 16px;
        padding: 2px 3px;
        color: #ff8300;
        line-height: 12px;
        border-radius: 2px;
        border: 1px solid #ff8300;
        display: flex;
        align-items: center;
        margin-right: 8px;
      }
    }
    &__desc {
      margin-bottom: 2px;
      font-size: 12px;
      font-weight: 400;
      text-align: left;
      color: #8c8c8c;
      line-height: 1.5;
    }
    .bottom_button {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #1e8dff;
      line-height: 14px;
      display: flex;
      align-items: center;
      padding-bottom: 16px;
      margin-top: 16px;
      cursor: pointer;
      img {
        width: 14px;
        height: 14px;
        margin-right: 4px;
      }
      span {
        display: flex;
        align-items: center;
        &.right {
          margin-right: 24px;
        }
      }
    }

    .store__button {
      width: 50%;
      color: #1e8dff;
    }
    .el-button + .el-button {
      margin-left: 0;
    }
  }
}
.show__more__btn {
  position: absolute;
  top: 2px;
  right: 0;
  cursor: pointer;
  font-size: 12px;
  &:hover {
    color: #1e8dff;
  }
}
</style>
